import React from "react";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BoxScoresTableViewModel} from "../models/box-scores.table.view-model";
import {BoxScoresWidgetTable} from "./box-scores-widget.table";
import {BoxScoresWidgetController} from "../box-scores-widget.controller";
import classnames from "classnames";
import styles from "../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTablesProps extends BaseProps {
  tables: Array<BoxScoresTableViewModel>;
  isExpandable: Boolean;
  isSmallView: Boolean;
  isRtl: Boolean;
  allStatsLabel: String;
  showAllStats: Boolean;
  shouldRenderEntityImage: Boolean;
  isPlayerCardPopupVisible: Boolean;
  shouldPlayerClickable: Boolean;
  allStatsToggle: Function;
  tableCellWidth: Number;
  selectedAthleteId: Number;
  controller: BoxScoresWidgetController;
}

export const BoxScoresWidgetTables = (({controller}: BoxScoresWidgetTablesProps) => {
  const {state} = controller;
  const {tables} = state;

  return (
    <div className={classnames(styles.tables_container)}>
      {
        tables.map(table => <BoxScoresWidgetTable table={table} key={table.id} controller={controller}/>)
      }
    </div>
  )
});
